import classNames from 'classnames';
import { ReactNode } from 'react';
import { Size } from '../../types';
import styles from './CheckboxRadioLabel.module.scss';

type Props = {
  disabled?: boolean;
  size: Size<'sm' | 'md'>;
  subtext?: ReactNode;
  text: ReactNode;
};

const CheckboxRadioLabel = ({ text, subtext, size, disabled }: Props) => {
  return (
    <div className={classNames(styles.labelElement, styles[size], { [styles.disabled]: disabled })}>
      <span className={styles.text}>{text}</span>
      {subtext ? <span className={styles.subtext}>{subtext}</span> : null}
    </div>
  );
};

export default CheckboxRadioLabel;
